import { Banner } from "@minuthq/meatball-ui-react"

import { usePatchParadiseLLMPrompt } from "src/data/paradise/paradiseLLMPrompts/queries/paradiseLLMPromptsQueries"
import { ConfirmDialog } from "src/ui/Dialog/ConfirmDialog"

export function ParadiseSetDefaultDialog({
  onClose,
  promptId,
}: {
  onClose: () => void
  promptId: string
}) {
  const patchParadiseLLMPrompt = usePatchParadiseLLMPrompt()

  function setAsDefault() {
    patchParadiseLLMPrompt.mutate(
      {
        path: {
          prompt_id: promptId,
        },
        body: {
          default: true,
        },
      },
      {
        onSuccess: () => {
          onClose()
        },
      }
    )
  }

  return (
    <ConfirmDialog
      open={true}
      onClose={onClose}
      title="Set as default"
      confirmLabel="Set as default"
      onConfirm={setAsDefault}
      loading={patchParadiseLLMPrompt.isPending}
    >
      <Banner type="warning" fullWidth>
        This will set this prompts as default for this category
      </Banner>
    </ConfirmDialog>
  )
}
